import { FootchinkoItem } from "./FootchinkoItem";
import { FootballFieldState } from "../../scenes/match-scene/FootballFieldState";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { MatchManager } from "../../MatchManager";
import { AudioManager } from "../../AudioManager";

export class Streaker extends FootchinkoItem {

    private end_px: number;
    private insideField_px: number;
    private pegsContainer: Phaser.Group;

    constructor(game: Phaser.Game, x: number, y: number, rightItem: boolean) {

        super(game, x, y, "texture_atlas_1", false, false, 0, rightItem);

        this.canBeHit = false;

        this.body.velocity.y = 75;

        if (this.rightItem) {

            this.body.velocity.x = -175;

            this.end_px = -200;
            this.insideField_px = 775;

        } else {

            this.x = -125;
            this.body.velocity.x = 175;

            this.end_px = 900;
            this.insideField_px = -20;
        }

        this.pegsContainer = FootballFieldState.currentInstance.pegsContainer;
    }

    public setBody(): void {

        this.body.allowGravity = false;
        this.body.allowRotation = false;
        this.body.setZeroVelocity();

        this.body.data.type = Phaser.Physics.P2.Body.KINEMATIC;

        if (this.rightItem) {
            this.body.setCircle(50, -30, -15);
        } else {
            this.body.setCircle(50, 30, -15);
        }

        this.body.angularVelocity = 0;
        this.body.fixedRotation = false;
        this.body.setZeroDamping();

        this.body.setMaterial(GameVars.getInstance().materials.pegMaterial);
    }

    public setView(): void {

        super.setView();

        this.name = GameConstants.STREAKER;

        this.animations.add("run", Phaser.Animation.generateFrameNames("male_streaker", 1, 14, "", 4));
        let hitAnimation: Phaser.Animation = this.animations.add("hit", Phaser.Animation.generateFrameNames("male_streaker", 15, 26, "", 4), 16, false);
        hitAnimation.onComplete.add(this.removeStreaker, this);
        this.animations.play("run", 20, true);

        let scaleX: number = this.rightItem ? 1 : -1;
        this.scale.set(scaleX, 1);
    }

    public update(): void {

        // mirar si ha salido de los limites
        if (this.rightItem) {

            if (!this.canBeHit && this.x < this.insideField_px) {
                this.canBeHit = true;
            }

            if (this.x < this.end_px) {
                this.destroy(true);
            }

        } else {

            if (!this.canBeHit && this.x > this.insideField_px) {
                this.canBeHit = true;
            }

            if (this.x > this.end_px) {
                this.destroy(true);
            }
        }
    }

    public hit(): void {

        super.hit();

        this.body.destroy();
        this.body = null;
        this.animations.play("hit");

        // informar al modelo
        MatchManager.onStreakerHit();
        AudioManager.getInstance().playEffect("power_up");
    }

    public removeStreaker(): void {

        this.game.add.tween(this).to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true, 800)
            .onComplete.add(this.kill, this);
    }
}
